// extracted by mini-css-extract-plugin
module.exports = {"heading":"Title_heading_1Ys6J"};